import React, { FormEvent, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { AcceptPoliciesChallenge, AuthChallenge, AuthHelper, AuthToken } from '../../helpers/AuthHelper';
import { Spinner } from 'react-bootstrap';

interface AcceptPoliciesFormProps {
  challenge: AcceptPoliciesChallenge;
  onCompleted: (authToken?: AuthToken|AuthChallenge) => void;
  onReturn: () => void;
}

export function AcceptPoliciesForm({ challenge, onCompleted, onReturn }: AcceptPoliciesFormProps): JSX.Element {
  const [acceptedDataPolicy, setAcceptedDataPolicy] = useState(false);
  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
  const [submitError, setSubmitError] = useState<string|null>(null);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  const handleSubmit = (event: FormEvent): void => {
    event.preventDefault();
    setSubmitError(null);
    setSubmitLoading(true);
    AuthHelper.handleAcceptPoliciesChallenge(challenge)
      .then(onCompleted)
      .catch(err => {
        setSubmitError('Opslaan gegevens mislukt door een onverwachte fout. Probeer het later opnieuw.');
        console.error('Unexpected accept policies challenge response:', err);
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleReturn = (): void => {
    onReturn();
  };

  return <Form className="form" onSubmit={handleSubmit}>
    <Form.Group>
      <Form.Check type="checkbox" id="acceptedDataPolicy">
        <Form.Check.Input type="checkbox" checked={acceptedDataPolicy} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setAcceptedDataPolicy(event.currentTarget.checked)} />
        <Form.Check.Label>
          MijnTOPP bevat vertrouwelijke en persoonlijke informatie. Ik zal zorgvuldig omgaan met
          deze gegevens, geen gegevens inzien die niet voor mij bedoeld zijn en geen anderen toegang
          geven tot gegevens die niet voor hen bedoeld zijn.
        </Form.Check.Label>
      </Form.Check>
    </Form.Group>

    <Form.Group>
      <Form.Check type="checkbox" id="acceptedPrivacyPolicy">
        <Form.Check.Input type="checkbox" checked={acceptedPrivacyPolicy} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setAcceptedPrivacyPolicy(event.currentTarget.checked)} />
        <Form.Check.Label>
          Ik ga akkoord met verwerking van mijn persoonlijke gegevens door TOPP-zorg voor het gebruik van MijnTOPP
          (zie ook het <a href="https://www.topp-zorg.nl/privacy-policy/" target="_blank">privacy statement</a> op onze website).
        </Form.Check.Label>
      </Form.Check>
    </Form.Group>

    { submitError && <Alert variant="danger">{submitError}</Alert> }
    <Button type="submit" className="form__submit" variant="primary" disabled={!acceptedDataPolicy || !acceptedPrivacyPolicy}>
      { submitLoading && <Spinner variant="primary" animation="border" /> }Accepteren
    </Button>
    <Button type="button" className="form__link" variant="link" onClick={handleReturn}>Ga terug</Button>
  </Form>;
}
